module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ap-gallery"
  }, _vm._l((_vm.images), function(image) {
    return _c('div', {
      key: image.id,
      staticClass: "position-relative ap-gallery__item",
      on: {
        "click": function($event) {
          _vm.handleImage(image.fullPath)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": image.fullPath
      }
    })])
  })), _vm._v(" "), _c('Lightbox', {
    attrs: {
      "visible": _vm.visible,
      "imgs": _vm.imgUrls,
      "index": _vm.index
    },
    on: {
      "hide": function($event) {
        _vm.handleImage('')
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-3082dcd4"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ApParts/ApGallery.vue
// module id = 1021
// module chunks = 1